import List from "./List";

const routes = [
    {
        path: 'brands',
        element: <List />
    }
]
export default routes;